const SHOPUPDATECOLLECTIONS = 'SHOP_UPDATE_COLLECTIONS'
export {
  SHOPUPDATECOLLECTIONS
}
